// MyImpactCard — "Meu Impacto" (P7 do módulo Compartilhar Esperança).
// Card discreto para usuários logados que já compartilharam ≥ 1 reflexão.
// Consome GET /api/share/my-stats. Silencioso se anônimo, sem shares
// ou erro de rede, nunca quebra o layout.
//
// Regras do usuário:
// - Só aparece para logados
// - Só aparece se total_shares > 0
// - Navy #0D1B2A + gold #C9A961, sem exagero
// - Zero emoji (usa lucide-react)

import React, { useEffect, useState } from "react";
import { Sprout } from "lucide-react";
import { api } from "../../lib/api";

const TYPE_LABEL = {
  devocional: "Devocional",
  sermon: "Sermão",
  plan: "Plano",
  verse: "Versículo",
  prayer: "Oração",
  study: "Estudo",
};

export default function MyImpactCard({ variant = "default" }) {
  const [stats, setStats] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let alive = true;
    api
      .get("/share/my-stats")
      .then((r) => {
        if (alive) setStats(r.data);
      })
      .catch(() => {
        if (alive) setStats(null);
      })
      .finally(() => {
        if (alive) setLoaded(true);
      });
    return () => {
      alive = false;
    };
  }, []);

  if (!loaded) return null;
  if (!stats || (stats.total_shares || 0) === 0) return null;

  const total = stats.total_shares || 0;
  const week = stats.this_week || { shares: 0, clicks: 0 };
  const weekClicks = week.clicks || 0;
  const topTitle = stats.top_content_title;
  const topType = stats.top_content_type;
  const typeLabel = TYPE_LABEL[topType] || null;

  const highlight =
    weekClicks > 0
      ? weekClicks === 1
        ? "1 pessoa foi tocada esta semana"
        : `${weekClicks} pessoas foram tocadas esta semana`
      : total === 1
        ? "Sua primeira semente está plantada"
        : "Sua semeadura continua";

  return (
    <section
      data-testid="my-impact-card"
      className={`rounded-2xl bg-navy text-white/95 border border-gold/25 shadow-sm ${
        variant === "compact" ? "px-5 py-4" : "px-6 py-5"
      }`}
    >
      <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.3em] text-gold/90">
        <Sprout className="w-3.5 h-3.5" />
        Você semeou esperança
      </div>
      <p
        className="font-display text-2xl sm:text-[26px] leading-tight mt-2 text-gold"
        data-testid="my-impact-headline"
      >
        {highlight}
      </p>
      <p
        className="text-white/75 text-sm mt-2"
        data-testid="my-impact-total"
      >
        {total}{" "}
        {total === 1 ? "reflexão compartilhada" : "reflexões compartilhadas"}{" "}
        no total
      </p>
      {topTitle && (
        <p
          className="text-white/60 text-xs mt-3 leading-relaxed"
          data-testid="my-impact-top"
        >
          <span className="text-gold/80 uppercase tracking-widest text-[10px]">
            {typeLabel ? `${typeLabel} mais compartilhado ` : "Mais compartilhado "}
          </span>
          <br />
          <span className="text-white/80">&ldquo;{topTitle}&rdquo;</span>
        </p>
      )}
    </section>
  );
}
